import Vue from 'vue';
import VueMeta from 'vue-meta';
import VueGtm from '@gtm-support/vue2-gtm';
import axios from 'axios';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import i18n from './i18n';
import config from './config';

import './scss/index.scss';

const { global } = config;

Vue.config.productionTip = false;

const token = localStorage.getItem('user-token');
if (token) {
  axios.defaults.headers.common.Authorization = `Bearer ${token}`;
}

if (global.storeId) {
  axios.defaults.headers.common.storeId = global.storeId;
}

if (global.gtm) {
  Vue.use(VueGtm, {
    id: global.gtm,
    defer: false,
    compatibility: false,
    nonce: '2726c7f26c',
    enabled: true,
    debug: true,
    loadScript: true,
    vueRouter: router,
    ignoredViews: [],
    trackOnNextTick: false,
  });
}

Vue.use(VueMeta, { refreshOnceOnNavigation: true });

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
